<template>
  <!--新增门店账号-->
  <el-dialog title="新增账号" :visible.sync="showCreate" width="30%" destroy-on-close @close="$emit('update:show',false)">
    <el-form ref="ruleForm" :model="account" class="dialog-form" :rules="rules">
      <el-form-item label="账号" required :label-width="formLabelWidth" prop="account">
        <el-input v-model.trim="account.account" type="text" autocomplete="off" />
      </el-form-item>
      <el-form-item label="使用者昵称" :label-width="formLabelWidth" prop="real_name">
        <el-input v-model.trim="account.real_name" type="text" autocomplete="off" />
      </el-form-item>
      <el-form-item label="使用门店" prop="store_id" :label-width="formLabelWidth">
        <el-select
          v-model="account.store_id"
          clearable
          filterable
          remote
          reserve-keyword
          :remote-method="remoteMethod"
          placeholder="请选择门店"
          class="filter-item filter-form-item"
          :loading="remoteLoading"
        >
          <el-option
            v-for="(item, index) in storeList"
            :key="index"
            :label="item.store_name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="初始密码" :label-width="formLabelWidth">
        jinduo{{ new Date()|parseTime('{y}{m}{d}') }}
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="$emit('update:show', false)">取 消</el-button>
      <el-button type="primary" :loading="loading" @click="onSubmit('ruleForm')">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import _ from 'lodash'
import { createStoreAccount as createAccount } from '@/api/storeAccount'
import { fetchStoreList } from '@/api/store'
import { ROLE_SERVER_ACCOUNT } from '@/constances/role'
export default {

  props: {
    storeOptions: {
      type: Array,
      default() {
        return []
      }
    },

    show: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      storeList: [],
      showCreate: this.show, // 打开密码修改
      account: { // 当前选中账号信息
        account: '',
        real_name: '',
        role_id: ROLE_SERVER_ACCOUNT,
        store_id: ''
      },
      info: this.accountInfo,
      formLabelWidth: '100',
      rules: {
        account: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        store_id: [{ required: true, message: '请选择使用门店', trigger: 'change' }]
      },
      remoteLoading: false,
      loading: false
    }
  },

  watch: {
    show(n) {
      this.showCreate = this.show
      if (n) {
        this.fetchStoreList()
      } else {
        this.account = { // 当前选中账号信息
          account: '',
          real_name: '',
          role_id: 6, // 门店账号固定role_id 6
          store_id: ''
        }
      }
    }
  },

  methods: {
    onSubmit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.loading = true
          createAccount({
            account: this.account.account,
            store_id: this.account.store_id,
            role_id: this.account.role_id,
            real_name: this.account.real_name
          }).then(response => {
            console.log(response)
            // 关闭弹层
            this.$emit('update:show', false)
            this.$emit('update')
            this.$message({
              message: '创建账号成功',
              type: 'success',
              duration: 3 * 1000
            })
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },

    // select远程搜索
    remoteMethod(query) {
      this.storeList = []
      if (query !== '') {
        this.remoteLoading = true
        this.fetchStoreList({ store_name: query })
      } else {
        // this.options = [];
        this.fetchStoreList()
      }
    },

    async fetchStoreList(params = {}) {
      try {
        const res = await fetchStoreList({
          ...params,
          limit: 50
        })
        this.storeList = _.get(res, ['data', 'data']) || []
        this.remoteLoading = false
        console.log(this.storeList)
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../styles/dialog-form.scss';
</style>
